/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTableProperty.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/audit-log-exclude";

export class AutogenModelTableProperty<RowType extends ModelRow> extends Endpoint<RowType, RowTablePropertyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTableProperty extends ModelRow<RowTablePropertyFields> {
	constructor(values?: Partial<RowTablePropertyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTablePropertyFields {
	company_id: string;
	field_name: string;
	table_name: string;
}

